import React, { useEffect, useState } from 'react';
import apiClient from '../api';
import {
    Box, Typography, TextField, Button, CircularProgress, Alert, InputAdornment,
} from '@mui/material';
import { glass } from '../theme';

function AdminSettings() {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    useEffect(() => {
        apiClient.get('/api/admin-panel/settings/')
            .then((res) => setSettings(res.data))
            .catch(() => setError('خطا در دریافت تنظیمات.'))
            .finally(() => setLoading(false));
    }, []);

    const handleSave = async () => {
        setSaving(true);
        setSuccess('');
        setError('');
        try {
            const res = await apiClient.patch('/api/admin-panel/settings/', settings);
            setSettings(res.data);
            setSuccess('تنظیمات با موفقیت ذخیره شد.');
        } catch {
            setError('خطا در ذخیره‌ی تنظیمات.');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}><CircularProgress /></Box>;
    }

    return (
        <Box>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 0.5 }}>تنظیمات مالی</Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
                این تنظیمات روی همه‌ی تسویه‌های بعدی با همیاران اثر می‌گذارد — تغییرات گذشته‌نگر نیست.
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

            <Box sx={{ ...glass.card, p: 3, maxWidth: 480, display: 'flex', flexDirection: 'column', gap: 3 }}>
                <TextField
                    label="درصد کارمزد پلتفرم"
                    type="number"
                    value={settings.commission_percent}
                    onChange={(e) => setSettings((s) => ({ ...s, commission_percent: e.target.value }))}
                    InputProps={{ endAdornment: <InputAdornment position="end">٪</InputAdornment> }}
                    helperText="این درصد از دستمزد هر همیار کسر و به‌عنوان درآمد پلتفرم ثبت می‌شود."
                    fullWidth
                />
                <TextField
                    label="مهلت نگهداری وجه پیش از واریز"
                    type="number"
                    value={settings.payout_hold_days}
                    onChange={(e) => setSettings((s) => ({ ...s, payout_hold_days: e.target.value }))}
                    InputProps={{ endAdornment: <InputAdornment position="end">روز</InputAdornment> }}
                    helperText="پس از اتمام کار، وجه تا این تعداد روز نزد پلتفرم می‌ماند و سپس برای واریز به همیار آماده می‌شود."
                    fullWidth
                />
                <Button variant="contained" size="large" disabled={saving} onClick={handleSave}>
                    {saving ? <CircularProgress size={22} color="inherit" /> : 'ذخیره‌ی تغییرات'}
                </Button>
            </Box>
        </Box>
    );
}

export default AdminSettings;
